var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M127.4,213.6C61.8,213.6,14,135.5,12,132.1l-2-3.3l1.7-3.5c1.6-3.4,40.5-83,115-83c74.3,0,115.8,79.4,117.5,82.8l1.8,3.6l-2,3.4c-2,3.3-49.3,80.5-115.4,81.5L127.4,213.6z M26.4,128.1c9.6,14.5,50.6,71.2,101,71.2h1c50.8-0.7,91.3-56.5,101.1-71.1c-8.7-14.8-45.6-71.5-102.8-71.5C69.5,56.7,34.6,113.3,26.4,128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M129.3,163.8c-21.5,0-38.9-17.5-38.9-38.9s17.5-38.9,38.9-38.9c21.5,0,38.9,17.5,38.9,38.9S150.8,163.8,129.3,163.8z M129.3,100.3c-13.6,0-24.6,11-24.6,24.6s11,24.6,24.6,24.6c13.6,0,24.6-11,24.6-24.6C153.9,111.3,142.9,100.3,129.3,100.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.eb3366c559877baf3cdf83459484e2ca.svg";
export { ForwardRef as ReactComponent };